﻿import { apiLink } from "./../../../constant/api-link";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { UserModel } from "../../../model/jubili/setting-user/user-data";

@Injectable()
export class EditRoleService {

    constructor(
        private http: HttpClient
    ) { }

    // search user backoffice
    searchUserBackOffice(email: string): Observable<UserModel> {
        const url = apiLink.getSearchJuAdminList;
        const params = new HttpParams()
            .set("email", email);

        return this.http.get<UserModel>(url, { params });
    }

    // update permission login
    updateBackOffice(userArray: Array<number>): Observable<boolean> {
        const url = apiLink.updateJuAdminLoginPermission;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.put<boolean>(url, userArray, { headers });
    }
}
